<template>
  <div class="row-fluid align-items-end" style="transition-delay: 0s">

<!--    <i class="fas fa-arrow-circle-left" @click="goBack()"></i>-->

    <h4 class="mt-0">Change Password</h4>
    <section class="bg-white mb-0">
        <div class="form-group">
          <label for="currentPassword">Current Password:</label>
          <input type="password" v-model="form.currentPassword" class="form-control" id="currentPassword" required>
        </div>
        <div class="form-group">
          <label for="newPassword1">New Password:</label>
          <input type="password" v-model="form.newPassword1" class="form-control" id="newPassword1" required>
        </div>
        <div class="form-group">
          <label for="newPassword2">Confirm New Password:</label>
          <input type="password" class="form-control" v-model="form.newPassword2" id="newPassword2" required>
        </div>
        <button type="submit" class="btn btn-primary mt-3 col" @click="changePassword">Change Password</button>
        <button type="reset" class="btn btn-outline-secondary col mt-4 bg-light" @click="reset">Cancel</button>

    </section>

  </div>
</template>

<script>

import axios from "axios";

export default {
  name: 'Password',
  components: {},
  props: [
    'user',
    'authenticated',
    'parent'
  ],
  data() {
    return {
      form: {
        'currentPassword': null,
        'newPassword1': null,
        'newPassword2': null
      }
    };
  },
  methods: {
    reset: function() {
      this.form.currentPassword = null;
      this.form.newPassword1 = null;
      this.form.newPassword2 = null;
    },
    changePassword: function () {
      let self = this;
      let formData = new FormData();
      formData.append('user_id', self.user.id);
      formData.append('currentPassword', self.form.currentPassword);
      formData.append('newPassword1', self.form.newPassword1);
      formData.append('newPassword2', self.form.newPassword2);
      axios.post("api/user/" + self.user.id + "/change-password", formData).then(response => {
        if (response.data) {
          if(response.data.error != '') {
            self.showAlert({'type' : 'danger', 'title' : '', 'message' : response.data.error});
          }
          if(response.data.success == 'true') {
            self.showAlert({'type' : 'success', 'title' : '', 'message' : 'Password has been updated, you will now need to log back into the App'});
            setTimeout(function(){ self.logout() }, 5000);
          }
        }
      });
    }
  },
  mounted() {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Password.vue